// Types
import { CbEntitlementType } from 'api/graphql-global-types';
import { GetMyEntitlements_getMyEntitlements } from 'api/brandSubscriptions/types/GetMyEntitlements';

type EntitlementTypename =
  | 'CbTalentBookingResearchEntitlement'
  | 'CbAdNewsFeedProEntitlement'
  | 'CbAppliedTalentAudienceReportEntitlement'
  | 'CbChatBroadcastAllEntitlement'
  | 'CbMyTalentEntitlement'
  | 'CbNoLaunchFeeEntitlement'
  | 'CbPremiumCampaignInsightsEntitlement'
  | 'CbPremiumFilterEntitlement'
  | 'CbRemoveMentionEntitlement'
  | 'CbZeroProcessingFeeEntitlement'
  | 'CbCampaignTalentInviteLinkEntitlement'
  | 'CbSocialBoostEntitlement'
  | 'CbAffiliateOfferingEntitlement'
  | 'CbTeamEntitlement';

// Converts a technical entitlement typename into readable text
export function formatEntitlementType(
  entitlementType: CbEntitlementType
): string {
  switch (entitlementType) {
    case CbEntitlementType.TalentBookingResearch:
      return 'Talent Booking Research';
    case CbEntitlementType.AdNewsFeed:
      return 'Ad News Feed Pro';
    case CbEntitlementType.AppliedTalentAudienceReport:
      return 'Applied Talent Audience Report';
    case CbEntitlementType.NoLaunchFee:
      return 'No Launch Fee';
    case CbEntitlementType.PremiumCampaignInsights:
      return 'Premium Campaign Insights';
    case CbEntitlementType.PremiumFilter:
      return 'Premium Filter';
    case CbEntitlementType.RemoveMention:
      return 'Remove Mention';
    case CbEntitlementType.ZeroProcessingFee:
      return 'Zero Processing Fee';
    case CbEntitlementType.CampaignTalentInviteLink:
      return 'Campaign Talent Invite Link';
    case CbEntitlementType.ChatBroadcastAll:
      return 'Chat Broadcast All';
    case CbEntitlementType.MyTalent:
      return 'My Talent';
    case CbEntitlementType.SocialBoost:
      return 'Social Boost';
    case CbEntitlementType.AffiliateOffering:
      return 'Affiliate Offering';
    case CbEntitlementType.Team:
      return 'Team';
    default:
      return entitlementType;
  }
}
export function mapEntitlementTypenameToType(
  entitlementType: EntitlementTypename | string
): CbEntitlementType {
  switch (entitlementType) {
    case 'CbTalentBookingResearchEntitlement':
      return CbEntitlementType.TalentBookingResearch;
    case 'CbAdNewsFeedProEntitlement':
      return CbEntitlementType.AdNewsFeed;
    case 'CbAppliedTalentAudienceReportEntitlement':
      return CbEntitlementType.AppliedTalentAudienceReport;
    case 'CbNoLaunchFeeEntitlement':
      return CbEntitlementType.NoLaunchFee;
    case 'CbPremiumCampaignInsightsEntitlement':
      return CbEntitlementType.PremiumCampaignInsights;
    case 'CbPremiumFilterEntitlement':
      return CbEntitlementType.PremiumFilter;
    case 'CbRemoveMentionEntitlement':
      return CbEntitlementType.RemoveMention;
    case 'CbZeroProcessingFeeEntitlement':
      return CbEntitlementType.ZeroProcessingFee;
    case 'CbCampaignTalentInviteLinkEntitlement':
      return CbEntitlementType.CampaignTalentInviteLink;
    case 'CbChatBroadcastAllEntitlement':
      return CbEntitlementType.ChatBroadcastAll;
    case 'CbMyTalentEntitlement':
      return CbEntitlementType.MyTalent;
    case 'CbSocialBoostEntitlement':
      return CbEntitlementType.SocialBoost;
    case 'CbAffiliateOfferingEntitlement':
      return CbEntitlementType.AffiliateOffering;
    case 'CbTeamEntitlement':
      return CbEntitlementType.Team;
    default:
      return entitlementType as CbEntitlementType;
  }
}

export function getPremiumFilterEntitlement(
  entitlements: GetMyEntitlements_getMyEntitlements[] | null | undefined
): GetMyEntitlements_getMyEntitlements | undefined {
  if (!entitlements) {
    return undefined;
  }
  return entitlements.find(
    (entitlement) => entitlement.__typename === 'CbPremiumFilterEntitlement'
  );
}

export function canEditPremiumFilters(
  entitlements: GetMyEntitlements_getMyEntitlements[] | null | undefined
): boolean {
  const premiumFilterEntitlement = getPremiumFilterEntitlement(entitlements);
  return (
    premiumFilterEntitlement?.validUntil !== null &&
    premiumFilterEntitlement?.validUntil !== undefined
  );
}
